import type { CandidateStatus, CandidateStatusFilter } from '../../../types/aiRecruiter';

export type ManualCandidateDecisionStatus = Extract<CandidateStatus, 'QUALIFIED' | 'REJECTED'>;

export const resolveManualDecisionCandidateStatus = (
  status: ManualCandidateDecisionStatus,
): CandidateStatusFilter => {
  if (status === 'QUALIFIED') {
    return 'APPROVED';
  }
  return 'REJECTED';
};
